import { render, staticRenderFns } from "./ChangePriceDialog.vue?vue&type=template&id=f13e31b6&scoped=true&"
import script from "./ChangePriceDialog.vue?vue&type=script&lang=js&"
export * from "./ChangePriceDialog.vue?vue&type=script&lang=js&"
import style0 from "./ChangePriceDialog.vue?vue&type=style&index=0&id=f13e31b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13e31b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
